export interface RoomsApiModel {
 hotelSeasonNote: any;
 room: Room;
 pakage: any;
 limitCountNights: number;
 searchResultCityLink: string;
 limitCountNightRange: {
  limitFrom: number;
  limitTo: number;
};
isFavourite: boolean
}

export interface Room {
 userAuthenticated: boolean;
 priceGuarantee: boolean;
 briefPrice: BriefPrice;
 breakfastTypes: fastType;
 combenations: ComboRooms[];
 cardHeaderPartial: CardHeaderPartial;
 roomFilters: RoomFilter[];
 roomContainer: RoomModel[];
}
export interface fastType {
 hotelId: number;
 name: string;
}
export interface BriefPrice {
 roomId: number;
 ihoPrice: number;
 hotelPrice: number;
 hotelId: number;
 maxDiscount: number;
 isAverage: boolean;
 roomName: string | null;
 ihoPriceText: string;
 hasNightWithPrice: boolean;
 extraCapacityIhoPrice: number;
 // new
 promotion: any;
 promotions: any;
 outOfService: boolean;
 inService: boolean;
 serviceStatus: number | null;
 hasFreeNight: boolean;
}

export interface CardHeaderPartial {
 title: string;
 description: any;
 className: string;
 score: Score;
 link: any;
 button: any;
 pTag: boolean;
 discount: number;
}

export interface Score {
 scoreNumber: number;
 text: string;
 description: string;
 fill: boolean;
 solidType: any;
 total: number;
 poorRank: number;
 middleRank: number;
 goodRank: number;
 veryGoodRank: number;
 excellentRank: number;
 poorRankPercent: number;
 middleRankPercent: number;
 goodRankPercent: number;
 veryGoodRankPercent: number;
 excellentRankPercent: number;
 url: any;
}

export interface RoomFilter {
 name: string;
 id: number;
}

export interface RoomModel {
 id: number;
 isHourly: boolean;
 isMobileDevice: boolean | null;
 name: string;
 foreignName: string;
 packageId: number | null;
 mainPicture: MainPictureModel;
 roomInfos: RoomInfo[];
 roomSideRight: RoomSideRight;
 filterIds: number[];
}

export interface MainPictureModel {
 alt: string;
 jpg: string;
 lazy: boolean;
 thumbnailUrl: string;
 webp: string;
}

export interface RoomInfo {
 noPrice: boolean;
 lastRoomLeft: boolean;
 reservable: boolean;
 letMeKnow: boolean;
 canReserveByTour: boolean
 bestRoomClass: string;
 roomInfoHeader: RoomInfoHeader;
 roomCapacity: RoomCapacity;
 comboDetail?: any;
 roomCount: RoomCount;
 roomPrice: RoomPrice;
 roomDetail: RoomDetail;
 roomInfoFacility: RoomInfoFacility | null;
 roomAvailableDate: RoomAvailableDate;
}

export interface RoomInfoHeader {
 promotionId: number;
 promotionType: RoomCardClassUIEnum;
 description: string;
 title: string;
 countdownTimer: { currentDate: string; countdownDate: string };
}

export interface RoomCapacity {
 adultCapacity: number;
 infantCapacity: number;
 extraCapacity: number;
 extraCapacityPrice: number;
 extraCapacityText: string;
 hotelPolicyChildDescription: string;
}

export interface RoomCount {
 roomCollapseViewId: string;
 reservable: boolean;
 lastRroomLeft: boolean;
}

export interface RoomPrice {
 discount: number;
 price: Price;
}

export interface Price {
 startingText: string;
 oldPrice: boolean;
 boardPrice: number;
 ihoPrice: number;
 nights: number;
 averageIhoPrice: number;
 className: ClassName;
}

export interface ClassName {
 root: string;
 startingText: string | null;
 oldPrice: string;
 newPrice: string;
 toman: string;
}

export interface RoomDetail {
 nonRefundable: boolean;
 breakfast: boolean;
 lunch: boolean;
 dinner: boolean;
 foodText: string | null;
}

export interface RoomInfoFacility {
 roomSize: string;
 bedType: string;
 bedSize: string;
 roomName: string;
 extraCapacity: number;
 topRoomFacility: TopRoomFacility[];
}

export interface TopRoomFacility {
 id: number;
 name: string;
 iconClassName: string;
 svgPic: string;
}

export interface RoomAvailableDate {
 roomCollapseViewId?: string;
 // notEnteryForArrivalDate: boolean
 checkInLimit: boolean;
 checkOutLimit: boolean;
 dates: AvailableDateModel[];
}

export interface AvailableDateModel {
 ReservableStatus: string;
 DatePersian: string;
 Date: string;
}

export interface RoomSideRight {
 noPrice: boolean;
 roomInfoFacility: RoomInfoFacility2 | null;
}

export interface RoomInfoFacility2 {
 roomSize: string;
 bedType: string;
 bedSize: string;
 roomName: string;
 extraCapacity: number;
 topRoomFacility: TopRoomFacility2[];
}

export interface TopRoomFacility2 {
 id: number;
 name: string;
 iconClassName: string;
}

export interface Info {
 roomId: number;
 description?: string;
 roomInfoFacility: RoomInfoFacility3;
 price: Price2;
 roomFacilityCat: RoomFacilityCat[];
}

export interface RoomInfoFacility3 {
 roomSize: string;
 bedType: string;
 bedSize: string;
 roomName: string;
 extraCapacity: number;
 topRoomFacility: TopRoomFacility3[];
}

export interface TopRoomFacility3 {
 id: number;
 name: string;
 iconClassName: string;
 svgPic: string;
}

export interface Price2 {
 startingText: string;
 oldPrice: boolean;
 boardPrice: number;
 ihoPrice: number;
 nights: number;
 averageIhoPrice: number;
 className: ClassName2;
}

export interface ClassName2 {
 root: string;
 startingText: string;
 oldPrice: any;
 newPrice: string;
 toman: string;
}

export interface RoomFacilityCat {
 name: string;
 id: number;
 facilities: string[];
}

export interface Slider {
 url: string;
 alt: string;
 width: number;
 height: number;
 thumbnailUrl: string;
}

export interface ComboRooms {
 combenationId: string;
 rooms: ComboRoomModel[];
 totalPrice: {
  nights: number;
  ihoPrice: number;
 };
}

export interface ComboRoomModel {
 roomId: number;
 roomName: string;
 attributes: Array<{
  iconclass: string;
  title: string;
  description: string;
  badges: any;
  position: number;
 }>;
 priceInfo: {
  boardPrice: number;
  ihoPrice: number;
  checkInDate: string;
  checkOutDate: string;
  nights: number;
  discountPercentage: number;
 };
 thumbnail: {
  jpg: string;
  webp: string;
 };
}

export enum RoomCardClassUIEnum {
  NonRefundable = 0,
  EarlyBooking = 1,
  FreeNight = 2,
  LastMinute = 3,
  Normal = 4,
  Full = 5,
}
